import { Bean, HeartHandshake, MoonStar } from "lucide-react";
import { IMAGES } from "../data/cafeData";

const PILLARS = [
  {
    icon: Bean,
    title: "Direct-trade beans",
    text: "Rotating single origins sourced straight from smallholder farms, roasted for clarity.",
  },
  {
    icon: HeartHandshake,
    title: "YYC rooted",
    text: "Local milk, local bakers, local artists on the walls. Community first, always.",
  },
  {
    icon: MoonStar,
    title: "Open every day",
    text: "From 8 AM mornings to 10 PM on weekends — a warm corner whenever you wander in.",
  },
];

export const About = () => (
  <section id="story" data-testid="about-section" className="bg-[#FDFBF7] py-24 md:py-32">
    <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 md:grid-cols-2 md:px-8 lg:gap-20">
      <div className="relative">
        <div className="overflow-hidden rounded-[2rem]">
          <img
            src={IMAGES.latteArt}
            alt="Barista pouring latte art at Nomad Cafe"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div className="absolute -bottom-8 -right-4 w-44 overflow-hidden rounded-3xl border-8 border-[#FDFBF7] shadow-xl md:-right-8 md:w-56">
          <img
            src={IMAGES.barista}
            alt="Precision barista pour"
            className="aspect-square w-full object-cover"
          />
        </div>
        <span className="absolute -left-3 top-8 rounded-full bg-[#C86D51] px-4 py-2 font-accent text-xs font-semibold uppercase tracking-[0.2em] text-[#FDFBF7] shadow-lg">
          Est. in Calgary
        </span>
      </div>

      <div>
        <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
          Our Story
        </p>
        <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#2C1D11] sm:text-3xl lg:text-4xl">
          A wanderer's cafe in the heart of the northwest
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#4A3B32]">
          Nomad Cafe began with a simple idea: a coffee shop should feel like the best
          part of a journey — unhurried, warm, and full of small discoveries. Every cup
          starts with beans we can trace back to the farm, pulled with care and served
          in a space built for lingering.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[#4A3B32]">
          From sunrise regulars to the late-night crowd, we're your corner of Royal
          Vista to settle in, fuel up, and wander on.
        </p>

        <div className="mt-10 space-y-6">
          {PILLARS.map((p) => (
            <div key={p.title} className="flex gap-4" data-testid={`pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#F5EFE6] text-[#C86D51]">
                <p.icon size={19} strokeWidth={2} />
              </span>
              <div>
                <h3 className="font-accent text-base font-semibold text-[#2C1D11]">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-[#6E5E53]">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
